import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";

import CustomButton from "../../../../common/CustomButton";
import { callSocket } from "../../../../utils/socket"

import ActivityEssential from "../../animations/activity_ess.json";
import PhoneAnimation from "../../animations/phone_animation.json";


function AppNotifPermPrompt({ closeSlider, type = "onboarding" }) {
    const navigate = useNavigate();

    const platform = localStorage.getItem("indi-platform");

    return (
        <>
            <div id="app-notif-perm-prompt">
                {/* {type == "existing" && <Logout showLogo showLogout={false} />} */}

                <div id="anpp-prompt-contrainer">
                    <div className="g-pink" id="lottie-container">
                        <Lottie className="activity-ess-animation" animationData={PhoneAnimation} loop={true} />
                    </div>

                    <div id="anpp-prompt">

                        {
                            type == "onboarding" && <h3> Program Added! </h3>
                        }

                        <h2>
                            Be the First to Know!
                        </h2>
                        {/* {
                            type == "existing"
                                ? <h4>
                                    Can we help you stay on track?
                                </h4>
                                : <h4>
                                    Final Step
                                </h4>
                        } */}
                        <p>
                            Get notified about new workout programs, new challenges, and important indi updates!
                        </p>
                        <div className="prompt-buttons">

                            <CustomButton className="active" onClick={() => {
                                callSocket("/interact-native-component", { type: "notification" });
                            }}>Turn on Notifications</CustomButton>

                            <p onClick={() => {
                                closeSlider();
                                localStorage.setItem("notif-prompt", true)
                            }}>No Thanks</p>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AppNotifPermPrompt;